import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const CalendarIcon = withSvgIcon(
    <g>
        <path d="M390.1 86V62.5h-93.3V86H203V62.5h-93.3V86H62.5v351.5h375V86h-47.4zm-70.2-.5h47.3V110h-47.3V85.5zm-187.1 0H180V110h-47.3V85.5zm-23 23.5v24H203v-24h93.9v24h93.3v-24h24.4v46.5h-329V109h24.2zm162.7 257.5v-47H321v47h-48.5zM321 389v25.5h-48.5V389H321zm-48.5-92v-47H321v47h-48.5zm-22.5 0h-71v-47h71v47zm0 22.5v47h-71v-47h71zm0 69.5v25.5h-71V389h71zm93.5 25.5V389h46.6v-22.5h-46.6v-47H390V297h-46.5v-47H390v-22.5h-46.5V203H321v24.5h-48.5V203H250v24.5h-71V203h-22.5v24.5h-46.8V250h46.8v47h-46.8v22.5h46.8v47h-46.6V389h46.6v25.5h-71V178h329v236.5h-71z" />
    </g>
);
